<script lang="ts">
  export let iconSize: string | undefined = undefined;
  export let iconStyle: string | undefined = undefined;
</script>

<div class="iconPlay" class:stroke={iconStyle === 'stroke'} style:--icon-play-size={`var(--space-${iconSize})`} />

<style lang="scss">
  @layer standard-components {
    .iconPlay {
      --icon-color: var(--color-blue);
      display: inline-block;
      position: relative;
      width: var(--icon-play-size);
      height: var(--icon-play-size);
      vertical-align: middle;
      border-style: solid;
      border-width: 1px;
      border-radius: 100%;
      border-color: transparent;
      background-color: var(--icon-color);
      transition: background-color var(--duration-quick) var(--easing-sharp);

      &::before {
        content: ' ';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        border-style: solid;
        border-color: transparent;
        border-left-color: white;
        border-left-width: calc(calc(var(--icon-play-size) / 3) * 0.8660254038);
        border-top-width: calc(calc(var(--icon-play-size) / 3) / 2);
        border-bottom-width: calc(calc(var(--icon-play-size) / 3) / 2);
        transform: translate(-28%, -50%) rotate(360deg);
      }

      &.stroke {
        background-color: transparent;
        border-color: var(--color-white);
      }
    }
  }
</style>
